// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer Styles */
.footer {
    background-color: #333;
    color: #fff;
    padding: 3rem 0;
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
}

.footer-container {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
    margin-top: 60px;
    gap: 40px
}

.footer-section {
    padding-left: 1rem;
    width: 40%;
}

.footer-section h2 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #a83232; /* Orange color for logo */
    letter-spacing: 1px;
}

.footer-description {
    margin-top: 1rem;
    font-size: 0.7rem;
    line-height: 1.6;
    text-align: left;
}

.footer-links {
    width: 40%;
}

.footer-links h3 {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 1rem;
}

.footer-links ul {
    list-style: none;
    padding: 0;
}

.footer-links ul li {
    margin: 0.5rem 0;
}

.footer-links ul li a {
    text-decoration: none;
    color: #fff;
    font-size: 1rem;
    font-weight: 400;
    transition: color 0.3s ease;
}

.footer-links ul li a:hover {
    color: #a83232; /* Hover text color */
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    font-size: 0.9rem;
    color: #ccc;
}

/* Mobile Styles */
@media (max-width: 768px) {
    .footer-container {
        flex-direction: column;
        align-items: center;
        gap: 0;
    }

    .footer-section, .footer-links {
        width: 100%;
        text-align: center;
    }

    .footer-bottom {
        margin-top: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc,EAAE,0BAA0B;IAC1C,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc,EAAE,qBAAqB;AACzC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,MAAM;IACV;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["/* Footer Styles */\n.footer {\n    background-color: #333;\n    color: #fff;\n    padding: 3rem 0;\n    font-family: 'Roboto', sans-serif;\n    font-weight: 300;\n}\n\n.footer-container {\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-start;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 1rem;\n    margin-top: 60px;\n    gap: 40px\n}\n\n.footer-section {\n    padding-left: 1rem;\n    width: 40%;\n}\n\n.footer-section h2 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #a83232; /* Orange color for logo */\n    letter-spacing: 1px;\n}\n\n.footer-description {\n    margin-top: 1rem;\n    font-size: 0.7rem;\n    line-height: 1.6;\n    text-align: left;\n}\n\n.footer-links {\n    width: 40%;\n}\n\n.footer-links h3 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    margin-bottom: 1rem;\n}\n\n.footer-links ul {\n    list-style: none;\n    padding: 0;\n}\n\n.footer-links ul li {\n    margin: 0.5rem 0;\n}\n\n.footer-links ul li a {\n    text-decoration: none;\n    color: #fff;\n    font-size: 1rem;\n    font-weight: 400;\n    transition: color 0.3s ease;\n}\n\n.footer-links ul li a:hover {\n    color: #a83232; /* Hover text color */\n}\n\n.footer-bottom {\n    text-align: center;\n    margin-top: 2rem;\n    font-size: 0.9rem;\n    color: #ccc;\n}\n\n/* Mobile Styles */\n@media (max-width: 768px) {\n    .footer-container {\n        flex-direction: column;\n        align-items: center;\n        gap: 0;\n    }\n\n    .footer-section, .footer-links {\n        width: 100%;\n        text-align: center;\n    }\n\n    .footer-bottom {\n        margin-top: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
